import type { CommendaAiScope } from '@commenda/api/commenda-ai/api';
import { useContext } from 'react';
import { useCommendaAiHost } from './CommendaAiHostProvider';
import { CommendaAiWorkspaceContext } from './CommendaAiWorkspaceProvider';

/** The workspace a chat surface is scoped to: the provider's override when mounted, otherwise the
 * host app's own config. An override is always resolved, so `isLoading` is false on that path.
 * `scope` is only ever set by an override; the host config is always one company. */
export const useCommendaAiWorkspace = (): {
  companyId: number | null;
  isLoading: boolean;
  workspaceName?: string;
  scope?: CommendaAiScope;
} => {
  const override = useContext(CommendaAiWorkspaceContext);
  const { companyId, isWorkspaceLoading } = useCommendaAiHost();

  if (override)
    return {
      companyId: override.companyId,
      isLoading: false,
      workspaceName: override.workspaceName,
      scope: override.scope,
    };

  return { companyId, isLoading: isWorkspaceLoading };
};
